module.exports = __webpack_public_path__ + "assets/img/registerBg.48a16cb6.png";